
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"39.949"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.144.002a.8.8 0 00-.549.325l-1.873 2.4H3.556a.8.8 0 00-.8.8v3.166L.36 8.565a.8.8 0 000 1.248l2.4 1.873v2.372a.8.8 0 101.6 0v-2.8a.8.8 0 00-.325-.624l-1.9-1.448 1.9-1.448a.8.8 0 00.325-.624v-2.8h2.8a.8.8 0 00.624-.325l1.439-1.887 1.448 1.9a.8.8 0 00.624.325h2.8v2.8a.8.8 0 00.325.624l1.9 1.448-1.9 1.448a.801.801 0 00.974 1.273l2.7-2.1a.8.8 0 000-1.248l-2.4-1.873V3.522a.8.8 0 00-.8-.8H11.72L9.844.326a.8.8 0 00-.7-.324zm.075 4.794a4.394 4.394 0 104.394 4.394 4.4 4.4 0 00-4.39-4.395zm0 1.6a2.8 2.8 0 11-2.8 2.8 2.784 2.784 0 012.804-2.803zm16.4 6.367a.934.934 0 00-.1.025h-.025a.534.534 0 00-.1 0C9.432 12.835.385 18.827.385 18.827a.808.808 0 00-.35.674v11.834a.819.819 0 000 .474v7.34a.8.8 0 00.8.8h38.348a.8.8 0 00.8-.8V14.557a.8.8 0 00-.125-.624.373.373 0 00-.025-.05.83.83 0 00-.275-.225l-.025-.025h-.05l-.025-.025h-.05l-.025-.025h-.075a.854.854 0 00-.2-.025c-.315-.044-2.887-.378-6.916-.6a.786.786 0 00-.424-.025h-.024a121.433 121.433 0 00-5.892-.15.789.789 0 00-.226-.023zm.15 1.623c.98 0 1.91.028 2.8.05a37.844 37.844 0 00-5.618 3.845 49.122 49.122 0 00-14.277 20.07H1.633v-6.542C9.744 19.56 25.358 14.517 25.776 14.382zm6.167.175c.687.037 1.408.081 2 .125a35.415 35.415 0 00-3.992 4.24 65.463 65.463 0 00-10.335 19.425h-9.188a47.293 47.293 0 0113.557-18.825 30.821 30.821 0 017.966-4.969zm-11.06.025c-5.08 2.268-13.432 6.853-19.243 14.477V19.95c.79-.502 7.397-4.478 19.25-5.368zm15.355.275c.758.075 1.3.153 1.673.2-1.339 2.6-4.928 10.289-7.989 23.294h-8.608a63.223 63.223 0 019.887-18.43 26.6 26.6 0 015.043-5.068zm2.147 2.9v20.6h-6.81a110.514 110.514 0 016.816-20.608z","fill":"#38470b"}})])
          )
        }
      }
    